/**
 * 推送渠道通用工具。
 *
 * 约定：接口 GET /cron-jobs/push-channel-options 返回 [{ type, label, available }]，
 * available=true 表示该渠道已配置且通讯实例匹配当前数字人。
 */

/**
 * 计算「已保存但当前不可用」的推送渠道 type 列表。
 * 判定口径：以 available=true 的渠道为准；保存值里存在、但不在该集合里的即为失效。
 * 可同时覆盖「渠道被卸载」与「通讯实例与当前数字人不匹配」两种情况。
 *
 * @param {Array} options 接口原始渠道列表
 * @param {Array} saved 已保存/已选中的渠道 type 列表
 * @param {Boolean} loaded 是否成功拉取过（未成功时不判定，避免误报）
 * @returns {String[]} 失效渠道 type 列表
 */
export function getInvalidPushChannels(options, saved, loaded) {
  if (!loaded) return []
  const list = Array.isArray(saved) ? saved.filter(Boolean) : []
  if (!list.length) return []
  const available = new Set(
    (Array.isArray(options) ? options : [])
      .filter((o) => o && o.available)
      .map((o) => o.type)
  )
  return list.filter((t) => !available.has(t))
}

/** 渠道 type -> 展示名 的映射（优先接口 label，兜底 type） */
export function getPushChannelLabelMap(options) {
  const map = {}
  ;(Array.isArray(options) ? options : []).forEach((o) => {
    if (o && o.type) map[o.type] = o.label || o.type
  })
  return map
}

/** 把渠道 type 列表拼成展示文案（用「、」连接） */
export function getPushChannelText(options, types) {
  const map = getPushChannelLabelMap(options)
  return (Array.isArray(types) ? types : []).map((t) => map[t] || t).join('、')
}

/** 单个渠道 type 的展示名（优先接口 label，兜底 type） */
export function getPushChannelLabel(options, type) {
  const map = getPushChannelLabelMap(options)
  return map[type] || type
}
